export default __webpack_public_path__ + "static/media/arquit-node.6dcd8681.png";